import { CodeState } from '../../models/state';
import { actionTypes } from '../actions/code';

const initialState: CodeState = {
  codes: [],
};
const codeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CODES_SUCCESS: {
      return {
        ...state,
        codes: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default codeReducer;
